import React, { useCallback } from "react";
import { Box, Link } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Link as RouterLink, useLocation } from "react-router-dom";

import "../../assets/css/index.css";
import { PAGE } from "../../config/urls";
import { SocialLink } from "../../constants/company";

interface FooterProps {
  address: string[];
  phone: string;
  email: string;
  mapUrl: string;
  socialLinks: SocialLink[];
}

const Footer: React.FC<FooterProps> = ({
  address,
  phone,
  email,
  mapUrl,
  socialLinks,
}) => {
  const location = useLocation();

  const handleHomeClick = useCallback(() => {
    if (location.pathname === PAGE.DEFAULT) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname]);

  const getIcon = useCallback((type: string) => {
    switch (type) {
      case "instagram":
        return <InstagramIcon />;
      case "facebook":
        return <FacebookIcon />;
      default:
        return null;
    }
  }, []);

  return (
    <footer className="site-footer">
      <Box className="footer-container">
        {/* Contact details */}
        <Box className="footer-column">
          <Link
            component={RouterLink}
            to={PAGE.DEFAULT}
            className="footer-title"
            underline="none"
            onClick={handleHomeClick}
          >
            BM Homes
          </Link>

          <div className="footer-item footer-address">
            <LocationOnIcon />
            <div>
              {address.map((line, index) => (
                <p key={index}>{line}</p>
              ))}
            </div>
          </div>

          <div className="footer-item">
            <PhoneIcon aria-hidden="true" />
            <p>{phone}</p>
          </div>

          <div className="footer-item">
            <EmailIcon aria-hidden="true" />
            <p>{email}</p>
          </div>
        </Box>

        {/* Social media */}
        <Box className="footer-column footer-social">
          <p className="footer-title">Connect With Us</p>

          <div className="social-icons">
            {socialLinks.map((item) => (
              <a
                key={item.type}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Follow BM Homes on ${item.type.charAt(0).toUpperCase() + item.type.slice(1)}`}
              >
                {getIcon(item.type)}
              </a>
            ))}
          </div>
        </Box>
      </Box>

      <p className="footer-copy">
       ©{new Date().getFullYear()} BM Homes. All rights reserved.
      </p>
    </footer>
  );
};

export default React.memo(Footer);
